import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import countryReadAction from './countryRead.action.json' assert { type: 'json' }

const countryReadDefinition = defineReadAutoAction(countryReadAction, 'country')

export default countryReadDefinition
